import { ReactElement } from 'react'
import { MdDevicesOther, MdLaptop, MdOutlineTabletMac, MdOutlineVideogameAsset, MdOutlineWatch, MdSmartphone } from 'react-icons/md'

export const sbuIcon = (sbu: string): ReactElement => {
  switch (sbu) {
    case 'Smartphone':
      return <MdSmartphone />
    case 'Notebook':
      return <MdLaptop />
    case 'Tablet':
      return <MdOutlineTabletMac />
    case 'Smartwatch':
      return <MdOutlineWatch />
    case 'Consolas':
    case 'Consola':
      return <MdOutlineVideogameAsset />
    default:
      return <MdDevicesOther />
  }
}
